import { useSkillGrid } from "../model/useSkillGrid";
import { splitSkillCards } from "../model/skillGridLayout";
import type { Scene } from "@/shared/lib/advisorScene";

/**
 * C1(军师 2.0 UI,2026-08-17):技能卡降级为**输入框上方的一行示例 chips**。
 *
 * <p>2.0 自动路由之后,「先挑一个技能再动手」的前提消失了 —— 技能卡从「主入口」退化成「示例」。
 * 这里只取首屏推荐的前几张,渲成一行 pill:点 chip = 把这句话喂进对话(onPick),走自动路由,
 * 不是「选技能」。完整网格挪进「更多能力」抽屉(见 AdvisorChatPanel)。
 *
 * <p>场景相关技能(scene)提到最前,和 SkillGrid/SceneSkillBar 同一 splitSkillCards 口径。
 * 空/加载中不渲染(不占位、不闪)。
 */
export function SkillChips({
  onPick,
  scene,
  max = 5,
}: {
  onPick: (label: string) => void;
  scene?: Scene | null;
  max?: number;
}) {
  const { cards, loading } = useSkillGrid();
  if (loading || cards.length === 0) return null;

  const { firstScreen } = splitSkillCards(cards, undefined, scene?.skills ?? []);
  const picks = firstScreen.slice(0, max);
  if (picks.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-1.5" aria-label="试试这些">
      <span className="text-xs text-muted-foreground">试试:</span>
      {picks.map((c) => (
        <button
          key={c.name}
          type="button"
          onClick={() => onPick(c.label)}
          title={c.description}
          className="rounded-full border bg-muted/40 px-3 py-1 text-xs text-muted-foreground transition-colors hover:border-primary hover:text-foreground"
        >
          {c.label}
        </button>
      ))}
    </div>
  );
}
